import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  otp: '',
  page:'first',
  data_expiration:'',
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setOTP: (state, action) => {
      state.otp = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setDataExpiration: (state, action) => {
      state.data_expiration = action.payload;
    },
    clearData: (state) => {
      state.email = '';
      state.otp = '';
      state.page= 'first';
      state.data_expiration= '';
    },
  },
});

export const { setEmail, setOTP, setPage, setDataExpiration,clearData } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
